import pro1 from '../assets/interior2.png'
import pro2 from '../assets/gym.png'
import pro3 from '../assets/feedo.png'
import pro4 from '../assets/game2.png'
// import pro5 from '../assets/estate.png'
import pro5 from '../assets/zomato.png'
import pro6 from '../assets/todo.png'


const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "Interior Designer Website",
        text: "Showcasing innovative interior designs that transform spaces into functional art. Specializing in residential and commercial interiors, our portfolio highlights creative solutions, modern aesthetics, and personalized style.",
        view: "https://icravecreations.pages.dev/",
        source: "#"
    },

    {
        imgsrc: pro2,
        title: "Gym Website Design",
        text: "Elevate your fitness journey with a modern, dynamic gym website design. Featuring user-friendly navigation, sleek layouts, and engaging content, our designs are crafted to inspire and motivate every workout.",
        view: "https://fitzzclub.pages.dev/",
        source: "#"
    },

    {
        imgsrc: pro3,
        title: "FeeDo Restaurant",
        text: "Experience culinary excellence at FeeDo Restaurant, where gourmet flavors meet exquisite presentation. Our website offers a taste of our diverse menu, elegant ambiance, and exceptional dining experience.",
        view: "https://feed-o.pages.dev/",
        source: "#"
    },

    {
        imgsrc: pro4,
        title: "JavaScript Game",
        text: "Immerse yourself in the excitement of our JavaScript game, where engaging gameplay meets seamless performance. Built for fun and challenge, our game showcases interactive design and responsive controls.",
        view: "#",
        source: "#"
    },

    {
        imgsrc: pro5,
        title: "Zomato Clone Design",
        text: "Explore our modern Zomato clone static website, designed to connect food lovers with their favorite restaurants. With intuitive search, detailed menus, high-quality images, and seamless navigation, users can easily discover and explore nearby dining options for every craving.",
        view: "https://clonezomato.pages.dev/",
        source: "#"
    },

    {
        imgsrc: pro6,
        title: "To do List Application",
        text: "Stay organized with our To-Do List Application, designed for efficiency and simplicity. Manage tasks, set priorities, and track progress with a user-friendly interface tailored for productivity.",
        view: "https://todo-list-awt.pages.dev/",
        source: "#"
    },

];

export default ProjectCardData;